import { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Switch, Route, useLocation, useRouteMatch } from 'react-router-dom';

import ViewTitle from '../../common/view-title';
import Loader from '../../common/loader';
import NotFound from '../../common/not-found';

import GroupIndex from './group-index';
import GroupCreate from './group-create';
import GroupDetail from './group-detail';
import AddPolicies from '../components/add-policies';

import helpers from '../../utils/helpers';

const useStyles = makeStyles(() => ({
    root: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
    }
}));

const GroupRoutes = () => {

    const classes = useStyles();
    const { pathname } = useLocation();
    const { path } = useRouteMatch();
    const [state, setState] = useState({
        loading: true,
        permissions: {}
    });

    useEffect(() => {
        const validatePermissions = () => {
            const permissions = helpers.getPermissions(pathname);
            setState(prev => ({ ...prev, permissions, loading: false }));
        }

        validatePermissions();
    }, []);

    if (state.loading) return <Loader />;
    if (!state.permissions?.read_attr) return <NotFound />;

    return (
        <div className={classes.root}>
            <ViewTitle title='User groups' />

            <Switch>
                <Route exact strict path={path}><GroupIndex permissions={state.permissions} /></Route>
                <Route exact strict path={`${path}/create`}><GroupCreate permissions={state.permissions} /></Route>
                <Route exact strict path={`${path}/detail/:id`}><GroupDetail permissions={state.permissions} /></Route>
                <Route exact strict path={`${path}/detail/:id/add-policies`}><AddPolicies permissions={state.permissions} submodule={'Group'} /></Route>
                <Route path={`${path}/*`}><NotFound /></Route>
            </Switch>
        </div>
    );
}

export default GroupRoutes;